import * as service from './service'
export default {
  namespace: 'recruitSelectCity',
  state: {
    selectedCity: null,

    // 定位城市
    locationCity: {}
  },
  effects: {
    * cities ({ payload }, { call }) {
      return yield call(service.cities, { ...payload })
    },
    * cityStatus ({ payload }, { call }) {
      return yield call(service.cityStatus, { ...payload })
    },
    * popupOfCity ({ payload }, { call, put }) {
      const res = yield call(service.popupOfCity, payload)
      return res
    },
    * submitCity ({ payload }, { call }) {
      return yield call(service.submitCity, { ...payload })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
